import React from 'react';
import { Helmet } from 'react-helmet';
import HeroNew from '../components/HeroNew';
import BlogPreview from '../components/BlogPreview';

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>Renta de Generadores en Veracruz | Gensol</title>
        <meta name="description" content="Renta de generadores, torres luminarias y soldadoras en Veracruz y Sureste de México. Entrega rápida. Cotiza ahora." />
        <meta name="keywords" content="renta generadores Veracruz, plantas de luz, torres de iluminación, soldadoras eléctricas, generadores eléctricos, renta equipo industrial" />
        <link rel="canonical" href="https://www.gensolver.com" />
        <meta property="og:title" content="Renta de Generadores en Veracruz | Gensol" />
        <meta property="og:description" content="Renta de generadores, torres luminarias y soldadoras en Veracruz y Sureste de México. Entrega rápida. Cotiza ahora." />
        <meta property="og:url" content="https://www.gensolver.com/" />
        <meta property="og:type" content="website" />
      </Helmet>
      
      <main id="inicio" data-page="home" data-analytics-page="home">
        <HeroNew />
        
        {/* H1 SEO Headline */}
        <section className="py-8 bg-gray-200">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
              Renta de <span className="text-orange-500">Generadores Eléctricos</span>, 
              <br className="hidden md:block" />
              <span className="text-orange-500">Torres de Iluminación</span> y <span className="text-orange-500">Soldadoras</span>
            </h1>
            <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
              Soluciones completas en energía para tu proyecto en Veracruz y el sureste de México
            </p>
          </div>
        </section>
        
        {/* Quick Stats Section */}
        <section className="py-16 bg-gray-100">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              <div 
                className="text-center"
                data-analytics-element="stat-clients"
              >
                <div className="text-4xl md:text-5xl font-bold text-orange-500">300+</div>
                <div className="text-gray-600 mt-2">Clientes Satisfechos</div>
              </div>
              <div 
                className="text-center"
                data-analytics-element="stat-equipment"
              >
                <div className="text-4xl md:text-5xl font-bold text-orange-500">50+</div>
                <div className="text-gray-600 mt-2">Equipos Disponibles</div>
              </div>
              <div 
                className="text-center"
                data-analytics-element="stat-experience"
              >
                <div className="text-4xl md:text-5xl font-bold text-orange-500">15+</div>
                <div className="text-gray-600 mt-2">Años de Experiencia</div>
              </div>
              <div 
                className="text-center"
                data-analytics-element="stat-support"
              >
                <div className="text-4xl md:text-5xl font-bold text-orange-500">24/7</div>
                <div className="text-gray-600 mt-2">Soporte Técnico</div>
              </div>
            </div>
          </div>
        </section>

        {/* Blog Preview */}
        <BlogPreview />

        {/* CTA Section */}
        <section className="py-16 bg-gray-200">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              ¿Necesitas Energía para tu Proyecto?
            </h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Contamos con la más amplia variedad de generadores y equipos eléctricos para cualquier necesidad industrial, comercial o de eventos.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="/servicios"
                data-testid="home-cta-services"
                data-analytics-click="home-view-services"
                className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg font-semibold transition-all hover:scale-105"
              >
                Ver Nuestros Servicios
              </a>
              <a 
                href="/contacto"
                data-testid="home-cta-contact"
                data-analytics-click="home-request-quote"
                className="border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white px-8 py-4 rounded-lg font-semibold transition-all"
              >
                Solicitar Cotización
              </a>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default HomePage;
